import type { TimelineRound } from '../types/timeline'

/**
 * 规整时间线轮次：成功但无有效图片（须同时有展示地址与存储公开编号）时改为 UNAVAILABLE。
 */
export function normalizeTimelineRound(round: TimelineRound): TimelineRound {
  if (round.status === 'FAILED' || round.status === 'UNAVAILABLE' || round.status === 'CANCELLED') {
    return round
  }
  const deadline = round.pendingSubmitDeadline
  if (
    round.status === 'PENDING' &&
    round.items.length === 0 &&
    !round.taskId &&
    typeof deadline === 'number' &&
    deadline < Date.now()
  ) {
    return {
      ...round,
      pendingSubmitDeadline: undefined,
      status: 'CANCELLED',
      errorMessage: '等待发送已中断（例如刷新页面）',
    }
  }
  const sr = round.outputSuperResolution
  const per = sr?.perImageSuccess
  const valid = round.items.filter((i) => i.src?.trim() && i.storagePublicId?.trim())
  if (round.status === 'SUCCEEDED') {
    if (valid.length === 0) {
      return {
        ...round,
        status: 'UNAVAILABLE',
        items: [],
        outputSuperResolution:
          sr?.attempted === true ? { attempted: true } : undefined,
      }
    }
    if (valid.length !== round.items.length) {
      let nextSr = sr
      if (sr && Array.isArray(per) && per.length === round.items.length) {
        const aligned: boolean[] = []
        for (let i = 0; i < round.items.length; i++) {
          if (round.items[i].src?.trim() && round.items[i].storagePublicId?.trim() && i < per.length) {
            aligned.push(per[i]!)
          }
        }
        nextSr = { ...sr, perImageSuccess: aligned }
      }
      return {
        ...round,
        items: valid,
        ...(nextSr ? { outputSuperResolution: nextSr } : {}),
      }
    }
  }
  return round
}

export function normalizeTimelineRounds(rounds: TimelineRound[]): TimelineRound[] {
  return rounds.map(normalizeTimelineRound)
}
